/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { BaseGlobalConfiguration } from "Shared/Models";
import Coupon from "./Coupon";

type GlobalConfiguration = BaseGlobalConfiguration<Coupon>;
export default GlobalConfiguration;
